import React, { useEffect, useState } from "react";
import { Loading } from "../../../../../Helper/LogoLoader/LogoLoader";
import { useAuthDispatch, useAuthState } from "../../../../../Helper/Context/context";
import { useDispatch, useSelector } from "react-redux";
import { PlantationTypeTableDataAPI } from "../../../../../Helper/Redux/AdminDashboardSlice/PlantationDetailsPartFirstSlice";
import { Circle } from "../CommonCircle";

export default function PlantingTypeViewPopUp(props) {

    const { handleShowViewModal, ShowViewModal, T_BeneficiaryWisePlantation_FinancialYearDetailsID, M_BeneficiaryDetailsID } = props
    const { flag, data } = ShowViewModal

    const userDetails = useAuthState();
    const { UserID, token } = userDetails
    const dispatch = useDispatch()

    const [PlantingType, setPlantingType] = useState('')

    // console.log(flag)

    useEffect(() => {
        const Data = {
            T_BeneficiaryWisePlantation_FinancialYearDetailsID: T_BeneficiaryWisePlantation_FinancialYearDetailsID,
            M_BeneficiaryDetailsID: M_BeneficiaryDetailsID,
            M_TableUserMasterID: UserID,
            // Flag: flag,
            Top: '99999',
            token: token,
        }
        // console.log("Data",Data)
        dispatch(PlantationTypeTableDataAPI({ Data }))
    }, [])

    const { isLoading, tableData } = useSelector(state => state.PlantationTypeTableData)

    return (
        <>
            {isLoading && <Loading />}
            <div
                className="modal fade show"
                style={{ display: "block", backgroundColor: "#00000055" }}
            >
                <div className="modal-dialog modal-dialog-centered" role="document" >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title ml-4" id="exampleModalLongTitle">
                                Planting Type 
                            </h5>
                            <button
                                onClick={() => handleShowViewModal(false, '')}
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body mx-4">
                            {
                                tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((i, j) => {
                                    return (
                                        <div className="row">
                                            <div className="col-12">
                                                <Circle/>
                                                <span className="text-dark ">{i.m_PlantingType ? i.m_PlantingType : '-'} </span>

                                            </div>
                                        </div>

                                    )
                                })
                                    :
                                    <div className="row">
                                        <div className="col-6">
                                            <span className="text-dark fw-bold "> - </span>

                                        </div>
                                    </div>
                            }


                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
